import React, {
  ChangeEventHandler,
  Context,
  FocusEventHandler,
  useContext,
} from "react";
import { cepMask, cpfMask, phoneMask } from "../helpers/masks";
import useAjvValidationWithCtx from "./useAjvValidationWithCtx";

function useValidInputCtx<K extends Context<any>>(ctx: K, schemaName: string, name: string) {
  const { updateFormData, formData } = useContext(ctx);
  const { checkIsValid, isValid, resetOneInputError } = useAjvValidationWithCtx(ctx, schemaName, name);

  const changeInputValue = (newValue: string | boolean) => {
    name && updateFormData((oldValues: any) => {
       return {
        ...oldValues,
        userInputs: {
          ...oldValues.userInputs,
          [name]: newValue,
        },
      };
    });
  };

  const onChangeCtx: ChangeEventHandler<HTMLInputElement> | ChangeEventHandler<HTMLInputElement>  = (e) => {
    const { name, value } = e.target;
    if (name === "cep" && value.length > 0) {
      return  changeInputValue(cepMask(value));
    }

    if (name === "phone" && value.length > 0) {
      return changeInputValue(phoneMask(value));
    }

    if (name === "cpf" && value.length > 0) {
      return changeInputValue(cpfMask(value));
    }
    
    if (e.target?.type === "checkbox") {
      return changeInputValue(e.target?.checked);
    }

    return changeInputValue(value);
  };

  const onFocusReset: FocusEventHandler<HTMLInputElement> = () => {
    return resetOneInputError();
  };

  const onBlurCheck: React.FocusEventHandler<HTMLInputElement> = () => {
    checkIsValid();
  };

  return {
    isValidInput: isValid,
    error: formData.errors[name],
    inputParams: {
      onChange: onChangeCtx,
      onBlur: onBlurCheck,
      onFocus: onFocusReset,
    } as Partial<React.ParamHTMLAttributes<HTMLInputElement>>,
  };
}

export default useValidInputCtx;
